import { createFileRoute } from '@tanstack/react-router';
import CompanyTagsTemplate from '@/features/agent/company_tags/components/CompanyTagsTemplate';

export const Route = createFileRoute('/agent/company_tags')({
  component: CompanyTagsTemplate,
});
